import { LegrandGateway } from './LegrandGateway.model';
import { Operation } from '~/interfaces/device.interface';
import operations from '~/helpers/device-operations';

export class BNC1 extends LegrandGateway {

    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;

    get deviceOperations(): Operation[] {
        return super.deviceOperations.concat([
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
            operations.triggerLogsDump({ callback: this.triggerLogsDump }),
        ]);
    }
}
